export default __webpack_public_path__ + "static/media/icons.dc1d8071.svg";